import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Grid.module.css';

class Section extends PureComponent {
  render() {
    const {
      sectionId,
      hasContainer,
      marginBefore,
      marginBeforeMedium,
      marginBeforeSmall,
      padding,
      paddingMedium,
      paddingSmall,
      backgroundColor,
      children,
      classes,
      id
    } = this.props;
    const styleNames = {
      'grid-container': hasContainer,
      [`${backgroundColor}`]: backgroundColor
    };
    return (
      <div
        className={classNames(classes, `section-${id}`)}
        styleName={classNames('section', styleNames)}
        id={sectionId}
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `@media (min-width:1024px){
                      .section-${id} {margin-top:${marginBefore || '0px'};${
              padding ? `padding:${padding};` : ''
            }}
                      }
                      @media (min-width:640px) and (max-width:1023px){
                      .section-${id} {margin-top:${marginBeforeMedium ||
              '0px'};${paddingMedium ? `padding:${paddingMedium};` : ''}}
                      }
                      @media (max-width:639px){
                      .section-${id} {margin-top:${marginBeforeSmall ||
              '0px'};${paddingSmall ? `padding:${paddingSmall};` : ''}}
                      }
                  `
          }}
        />
        {children}
      </div>
    );
  }
}
Section.propTypes = {
  sectionId: PropTypes.string,
  hasContainer: PropTypes.bool,
  marginBefore: PropTypes.string,
  marginBeforeMedium: PropTypes.string,
  marginBeforeSmall: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.any,
  backgroundColor: PropTypes.string,
  id: PropTypes.number
};

export default DisplayComponent(Section);
